<div class="app-body" [ngClass]="{'app-bodyAuth':websiteName=='Parmed'}">
  <div *ngIf="isUnderMaintenance">
    <par-under-maintenance></par-under-maintenance>
  </div>
  <div *ngIf="!isUnderMaintenance">
    <div *ngIf="isMobileDevice(); then appMobile; else appDesktop"></div>
    <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
    <div class="parmed-spin-loading-container" *ngIf="isLoading">
      <mat-spinner diameter="100"></mat-spinner>
    </div>
  </div>
</div>

<ng-template #appDesktop>
  <div *ngIf="!chat.initiated">
    <par-header></par-header>
    <par-navbar [chatAvailable]="chat.available" [chatEnable]="chat.enable" [expertMedFlg] = "this.expertMedFlag" (onChatClick)="onInitiateChatClick()"></par-navbar>
    <div *ngIf="websiteName == 'Parmed'">
      <div #main id="main-content-wrapper" class="main-content-wrapper-inner desktop">
        <div class="banner-wrapper-inner">
          <!-- <div class="desktop-banner-inner-content"> -->
            <div *ngIf="websiteName == 'Parmed'">
              <div *ngIf="orderAccess.showDeniedMessage" class="no-order-access-message">
                {{ orderAccess.deniedMessage }}
              </div>
              <div *ngIf="customerAssociation.showAssociationMessage" class="no-order-access-message">
               {{customerAssociation.parmedAssociationMessage }}
              </div>
            </div>
            <!-- <div *ngIf="websiteName == 'Major'">
              <div *ngIf="orderAccess.showDeniedMessage" class="no-order-access-message">
                {{ orderAccess.majorDeniedMessage }}
              </div> 
            </div>-->
            <div style="display:table; width:100%;" *ngIf="pageBannerHeader">
              <div style="display:table-cell">
                <h1>
                  <span class="bold headerColor" id="header" [innerHTML]="pageBannerHeader"></span>
                  <span class="bold headerColor" *ngIf="exportToExcel!=''" id="header" style="font-size: 17px;" [innerHTML]="exportToExcel"></span>
                </h1>
                <div class="padding-bottom-5" *ngIf="isShoppingCart">
                  <span id = "cart-validity-msg" class="bold headerColor">Please be advised: 7 days after purchase order creation all unpurchased items will be removed from cart.</span>
                </div>
              </div>
              <div style="display:table-cell" *ngIf="showCheckOut">
                <div class="fright" style="margin-top: 20px;">
                  <button mat-raised-button id="btn-checkout" color="accent" (click)="onCheckoutClick()">
                    Proceed to Checkout
                  </button>
                </div>
              </div>
              <div style="display:table-cell" *ngIf="isShoppingCart">
                <div class="fright" style="margin-top: 20px;">
                  <button mat-raised-button id="btn-continue-shopping" color="accent" [routerLink]="[routes.home]">
                    Continue Shopping
                  </button>
                </div>
              </div>
            </div>
            <mat-divider *ngIf="pageBannerHeader"></mat-divider>
          <!-- </div> -->
        </div>
        <div class="content-wrapper">
          <div class="content-text-margin">
            <div class="content-wrapper-inner" id="inner-header" [innerHTML]="pageBannerContent"></div>
          </div>
          <div [ngClass]="{'content-wrapper-inner': !isHome}">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="websiteName == 'Major'">
      <div #main id="main-content-wrapper" class="main-content-wrapper-inner desktop" [ngClass]="{'majorPaddingHeader':!isHome && !isExcludePages && websiteName=='Major' }">
        <div class="banner-wrapper-inner">
          <!-- <div class="desktop-banner-inner-content"> -->
           <!-- <div *ngIf="websiteName == 'Parmed'">
              <div *ngIf="orderAccess.showDeniedMessage" class="no-order-access-message">
                {{ orderAccess.deniedMessage }}
              </div>
            </div> -->
            <div *ngIf="websiteName == 'Major'" style="margin-left: 20px;" [ngClass]="{'majorPaddingHeader':(isHome || isExcludePages) && isAuthenticated && websiteName=='Major' }">
              <div *ngIf="orderAccess.showDeniedMessage && getMessages()" class="no-order-access-message"  [innerHTML]="errorMsg">
              </div>
              <div *ngIf="customerAssociation.showAssociationMessage" class="no-order-access-message">
                {{customerAssociation.majorAssociationMessage}}
              </div>
            </div>
            <div style="display:table; width:100%;" *ngIf="pageBannerHeader" [ngClass]="{'header-major-desktop margin-14': websiteName === 'Major'}">
              <div style="display:table-cell">
                <h1>
                  <span class="bold headerColor" id="header" [innerHTML]="pageBannerHeader" [ngStyle]="{'margin-left':websiteName=='Major' && isAuthenticated?'15px':'0px','font-weight':websiteName=='Major' && isAuthenticated?'normal':'bold'}"></span>
                </h1>
                <div class="padding-bottom-5" *ngIf="isShoppingCart">
                  <span id = "cart-validity-msg" class="bold headerColor" [ngStyle]="{'margin-left':websiteName=='Major' && isAuthenticated?'17px':'0px'}">Please be advised: 7 days after purchase order creation all unpurchased items will be removed from cart.</span>
                </div>
              </div>
              <div style="display:table-cell" *ngIf="showCheckOut">
                <div class="fright" style="margin-top: 20px;"  [ngStyle]="{'padding-right':!isHome && !isExcludePages && websiteName=='Major' ?'20px':'0px'}">
                  <button mat-raised-button id="btn-checkout" color="accent" (click)="onCheckoutClick()">
                    Proceed to Checkout
                  </button>
                </div>
              </div>
              <div style="display:table-cell" *ngIf="isShoppingCart">
                <div class="fright" style="margin-top: 20px;"  [ngStyle]="{'padding-right':!isHome && !isExcludePages && websiteName=='Major' ?'20px':'0px'}">
                  <button mat-raised-button color="accent" [routerLink]="[routes.home]">
                    Continue Shopping
                  </button>
                </div>
              </div>
            </div>
            <mat-divider *ngIf="pageBannerHeader && websiteName == 'Major' && isAuthenticated"  [ngStyle]="{'margin-left':websiteName=='Major' && isAuthenticated?'20px':'','margin-right':websiteName=='Major' && isAuthenticated?'20px':''}"></mat-divider>
          <!-- </div> -->
        </div>
        <div class="content-wrapper">
          <div class="content-text-margin">
            <div class="content-wrapper-inner" [innerHTML]="pageBannerContent"></div>
          </div>
          <div [ngClass]="{'content-wrapper-inner': !isHome,'content-wrapper-inner-major':websiteName=='Major' && !isHome && !isProducts}">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>

    <par-footer></par-footer>
    <!-- <a
      *ngIf="chat.available"
      class="chatIcon"
      [class.disabled]="!chat.enable"
      (click)="onInitiateChatClick()"
      [@animateChatAlert]="currentIconState"
    >
      <img
        src="/assets/images/chat-icon.png"
        width="20px"
        height="20px"
      />&nbsp;{{ chat.enable ? chat.activeMessage : chat.inactiveMessage }}
    </a> -->
    <par-repchat-alert *ngIf="chat.showAlert" [repMessage]="repInitialMessage" [repName]="repName" [repImage]="currentChatSession.repImageURL"
      [@animateChatAlert]="currentAlertState" (show)="onToggleChatAlert($event)"></par-repchat-alert>
  </div>
  <div *ngIf="chat.initiated">
    <router-outlet></router-outlet>
  </div>
</ng-template>

<ng-template #appMobile>
  <div *ngIf="!isAuthenticated; then mobileUnauthTemplate; else mobileAuthTemplate"></div>
  <par-footer></par-footer>
</ng-template>

<ng-template #mobileUnauthTemplate>
  <div *ngIf="websiteName == 'Parmed'" #main id="main-content-wrapper" class="main-content-wrapper-inner">
    <div *ngIf="isHome; then unauthHomeTemplate; else mobileMainContainer"></div>
  </div>
  <div *ngIf="websiteName == 'Major'" #main id="main-content-wrapper" class="main-content-wrapper-inner">
    
    <div *ngIf="websiteName === 'Major'" class="menu-header">
      <img src="/assets/images/{{ websiteName }}/LogoNew.png" class="menu-logo" alt="" />
      <div class="menu-header-right">
        <span class="profile-icon-wrapper">
          <mat-icon (click)="onSignInClick()">person_outline</mat-icon>
        </span>
        <button *ngIf="!showMobileMenu" class="menu-icon-btn" (click)="showMobileMenu = true">
          <img src="/assets/images/mobile/icons8-menu-filled-48.png" style="height: 28px" alt="Menu" />
        </button>
        <button *ngIf="showMobileMenu" class="menu-close-btn" (click)="showMobileMenu = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="websiteName === 'Major' && showMobileMenu" class="mobile-fullscreen-menu">
      <div class="menu-header">
        <img src="/assets/images/Major/LogoNew.png" class="menu-logo" alt="Logo" />
        <div class="menu-header-right">
          <span class="profile-icon-wrapper">
            <mat-icon>person_outline</mat-icon>
          </span>
          <button class="menu-close-btn" (click)="showMobileMenu = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div class="nav-border">
      <div class="menu-items">
        <a [routerLink]="[routes.home]" (click)="showMobileMenu = false">Home</a>
        <a (click)="onAboutUsClick(routes.majorAboutUs);showMobileMenu = false">About</a>
        <a [routerLink]="[routes.productCatalogList]" (click)="showMobileMenu = false">Products</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.majorAmazon]" >Amazon</a>
    
        <a (click)="showMobileMenu = false" [routerLink]="[routes.news]">News</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.contactUs]">Contact Us</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.packageInsert]">Package Inserts</a>
      </div>
      <button class="sign-in-btn" (click)="onLogInClick(); showMobileMenu = false">
        <mat-icon>person_outline</mat-icon> Sign in
      </button>
      <div class="register-row">
        <b  style="color: #555; font-size: 17px;">New customer?</b>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.register]">Register</a>
        to get started.
      </div>
    </div>
    </div>
    <mat-sidenav-container class="mobile-sidenav-container">
      <mat-sidenav-content>
        <div *ngIf="isHome" class="home-container">
          
          <div *ngIf="websiteName == 'Major'">
            <home></home>
          </div> 
           <!-- <div *ngIf="isHome; then unauthHomeTemplate; else mobileMainContainer"></div> -->
          
        </div>
        <div style="display:table; width:100%;" *ngIf="pageBannerHeader" [ngClass]="{'header-padding': websiteName === 'Major'}">
          <div style="display:table-cell">
            <h1>
              <span class="bold headerColor" id="header" [innerHTML]="pageBannerHeader"></span>
            </h1>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="content-text-margin" [ngClass]="{'content-padding': websiteName === 'Major'}">
            <div class="content-wrapper-inner" id="inner-header" [innerHTML]="pageBannerContent"></div>
          </div>
          <div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</ng-template>
<ng-template #mobileAuthTemplate>
  <mat-toolbar color="primary" class="mobile-toolbar">
    <nav id="parmed-navbar" class="navbar navbar-default menu-bar">
      <div class="row">
        <div class="col-sm-2 col-xs-2 navbar-menu-search">
          <button type="button" class="navbar-toggle" (click)="mobileNav.toggle()">
              <img src="/assets/images/mobile/icons8-menu-filled-48.png" style="height: 28px" alt="" title="" />
          </button>
        </div>
        <div class="col-sm-8 col-xs-8">
          <div [ngClass]="{'parmed-logo': websiteName === 'Parmed', 'major-logo': websiteName === 'Major'}" (click)="onNavigationClick(routes.home)">
            <img src="/assets/images/{{ websiteName }}/LogoNew.png" class="logo" alt="" title="" />
          </div>
        </div>
        <div class="col-sm-2 col-xs-2 navbar-right-icons">
          <span matBadge="{{orderCount}}" matBadgeOverlap="true" matBadgeSize="medium" class="icon shopping-cart-icon"
            (click)="onCheckoutClick()"></span>
        </div>
      </div>
    </nav>
  </mat-toolbar>

  <mat-sidenav-container class="mobile-sidenav-container">
    <mat-sidenav #mobileNav mode="over" fixedTopGap="42" (click)="mobileNav.toggle()">
      <mat-nav-list>
        <a mat-list-item [routerLink]="[routes.home]">Home</a>
        <a mat-list-item [routerLink]="[routes.changeAccount]">Change Account</a>
        <a mat-list-item [routerLink]="[routes.orderHistory]">Order History</a>
        <a mat-list-item [routerLink]="[routes.changePassword]">Change Password</a>
        <a mat-list-item (click)="onSignOutClick()">Sign Out</a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>

      <div id="main-content-wrapper" class="main-content-wrapper-inner">
        <div class="search-navbar">
          <div *ngIf="isHome" class="welcome-message info">
            <p>
              <span class="message">
                Welcome, {{ userInfo.firstName }} {{ userInfo.lastName }}.
              </span>
            </p>
          </div>
          <div class="navbar-search mini-search-bar">
            <form action="." (ngSubmit)="$event.preventDefault(); onSearchProductsSubmit()" *ngIf="isAuthenticated">
              <input type="submit" class="search-btn" [ngClass]="{'search-top': !isHome, 'search-bottom': isHome}" value="" />
              <input type="search" id="searchvalue" class="form-control" placeholder="Search products" name="searchvalue"
                maxlength="100" [(ngModel)]="searchValue" (ngModelChange)="onSearchChange()" />
            </form>

          </div>
        </div>
        <div *ngIf="isHome; then authHomeTemplate; else mobileMainContainer"></div>
        <div *ngIf="isHome && !isApp && websiteName=='Parmed'" class="app-download">
          <p>Download our mobile app</p>
          <span class="icon app-store-download-icon" (click)="onAppDownload('apple')"></span>
          <span class="icon google-play-download-icon" (click)="onAppDownload('google')"></span>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-template>
<ng-template #mobileMainContainer>
  <div class="banner-wrapper-inner">
    <div class="mobile-banner-inner-content">
      <div style="display:table-cell" *ngIf="isProductDetailsFromSearch.showButton">
        <div class="fright" style="margin-top: 20px;">
          <button mat-raised-button [routerLink]="[isProductDetailsFromSearch.previousRoute]" color="accent">
            Back to Search Results
          </button>
        </div>
      </div>
      <div style="display:table; width:100%;">
        <div style="display:table-cell">
          <h1>
            <span class="bold headerColor" [innerHTML]="pageBannerHeader"></span>
          </h1>
        </div>
        <div style="display:table-cell" *ngIf="isProductSearch">
          <div class="fright" style="margin-top: 20px;">
            <button mat-raised-button color="accent" (click)="onCheckoutClick()">
              Proceed to Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper">
    <div class="content-wrapper-inner">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>

<ng-template #unauthHomeTemplate>
  <div #main id="main-content-wrapper" class="main-content-wrapper-inner">
    <mat-toolbar color="primary" class="mobile-toolbar">
      <nav id="parmed-navbar" class="navbar navbar-default menu-bar">
        <div class="row">
          <div *ngIf="websiteName === 'Parmed'" [ngClass]="{'parmed-logo': websiteName === 'Parmed'}">
            <div [ngClass]="{'parmed-logo': websiteName === 'Parmed', 'major-mobile col-sm-8 col-xs-8': websiteName === 'Major'}"
              (click)="onNavigationClick(routes.home)">
              <img src="/assets/images/{{ websiteName }}/LogoNew.png" style="max-width: 300px; max-height: 60px" class="logo" alt="" title="" />
            </div>
          </div>
          
        </div>
      </nav>
    </mat-toolbar>
    <div *ngIf="websiteName === 'Major'" class="menu-header">
      <img src="/assets/images/{{ websiteName }}/LogoNew.png" class="menu-logo" alt="" />
      <div class="menu-header-right">
        <span class="profile-icon-wrapper">
          <mat-icon (click)="onSignInClick()">person_outline</mat-icon>
        </span>
        <button *ngIf="!showMobileMenu" class="menu-icon-btn" (click)="showMobileMenu = true">
          <img src="/assets/images/mobile/icons8-menu-filled-48.png" style="height: 28px" alt="Menu" />
        </button>
        <button *ngIf="showMobileMenu" class="menu-close-btn" (click)="showMobileMenu = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="websiteName === 'Major' && showMobileMenu" class="mobile-fullscreen-menu">
      <div class="menu-header">
        <img src="/assets/images/Major/LogoNew.png" class="menu-logo" alt="Logo" />
        <div class="menu-header-right">
          <span class="profile-icon-wrapper">
            <mat-icon>person_outline</mat-icon>
          </span>
          <button class="menu-close-btn" (click)="showMobileMenu = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div class="menu-items">
        <a [routerLink]="[routes.home]" (click)="showMobileMenu = false">Home</a>
        <a (click)="onAboutUsClick(routes.majorAboutUs);showMobileMenu = false">About</a>
        <a [routerLink]="[routes.productCatalogList]" (click)="showMobileMenu = false">Products</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.majorAmazon]" >Amazon</a>
    
        <a (click)="showMobileMenu = false" [routerLink]="[routes.news]">News</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.contactUs]">Contact us</a>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.packageInsert]">Package inserts</a>
      </div>
      <button class="sign-in-btn" (click)="onLogInClick(); showMobileMenu = false">
        <mat-icon>person_outline</mat-icon> Sign in
      </button>
      <div class="register-row">
        <b  style="color: #555; font-size: 17px;">New customer?</b>
        <a (click)="showMobileMenu = false" [routerLink]="[routes.register]">Register</a>
        to get started.
      </div>
    </div>
    <mat-sidenav-container class="mobile-sidenav-container">
      <mat-sidenav-content>
        <div *ngIf="isHome" class="home-container" [ngClass]="{'water-mark-1': websiteName === 'Parmed'}">
          <div class="unauth-welcome-message" *ngIf="websiteName == 'Parmed'">
           Welcome to {{ websiteName }} Pharmaceuticals, your source for the highest quality pharmaceuticals and competitive pricing.
          </div>
          <div *ngIf="websiteName == 'Major'">
            <home></home>
          </div> 
           <!-- <div *ngIf="isHome; then unauthHomeTemplate; else mobileMainContainer"></div> -->
          <div class="home-action-icons" *ngIf="websiteName == 'Parmed'">
            <div>
              <span class="icon login-icon" id="sign-in" (click)="onLogInClick()"></span>
              <p>Sign In</p>
            </div>
            <div>
              <span class="icon forgot-password-icon" (click)="onNavigationClick(routes.forgotPassword)"></span>
              <p>Forgot Password</p>
            </div>
          </div>
        </div>
        <div style="display:table; width:100%;" *ngIf="pageBannerHeader" [ngClass]="{'header-padding': websiteName === 'Major'}">
          <div style="display:table-cell">
            <h1>
              <span class="bold headerColor" id="header" [innerHTML]="pageBannerHeader"></span>
            </h1>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="content-text-margin" [ngClass]="{'content-padding': websiteName === 'Major'}">
            <div class="content-wrapper-inner" id="inner-header" [innerHTML]="pageBannerContent"></div>
          </div>
          <div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</ng-template>



<ng-template #authHomeTemplate>
  <div class="home-container" [ngClass]="{'water-mark-2': websiteName === 'Parmed'}">
    <div class="has-error okta-error" *ngIf="customerAssociation.showAssociationMessage">
      <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
      <div *ngIf="websiteName == 'Parmed'">
        <p class="show-message">
          <span>{{customerAssociation.parmedMobileAssociationMessage}}</span>
        </p>
      </div>
      <div *ngIf="websiteName == 'Major'">
        <p class="show-message">
          <span>{{customerAssociation.majorMobileAssociationMessage}}</span>
        </p>
      </div>
    </div>
    <div class="has-error okta-error" *ngIf="orderAccess.showDeniedMessage">
      <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
      <div *ngIf="websiteName == 'Parmed'">
        <p class="show-message">
          <span>{{ orderAccess.mobileDeniedMessage }}</span>
        </p>
      </div>
      <div *ngIf="websiteName == 'Major'">
        <p  *ngIf= "getMessages()" class="show-message">
          <span  [innerHTML]="errorMsg"></span>
        </p>
      </div>
    </div>
    <div class="home-action-icons">
      <div>
        <span class="icon order-history-icon" (click)="onNavigationClick(routes.orderHistory)"></span>
        <p>Order History</p>
      </div>
      <div>
        <span class="icon change-account-icon" (click)="onNavigationClick(routes.changeAccount)"></span>
        <p>
          <span>Change Account</span> <br />
          <span class="account-name"> {{ userInfo.accountName }}</span>
        </p>
      </div>
    </div>
  </div>
</ng-template>